<template>
  <div class="ax-result-page">
    <div class="result-box">
      <img class="bigImg" :src="imgSrc" alt />
      <p>{{text}}</p>
      <p class="gray">{{subtext}}</p>
    </div>
  </div>
</template>

<script>
  import { empty , network , lost} from '@/assets/js/imgSrc'
  export default {
    name: 'ax-result-page',
    props: {
      type: [String],
      text:[String],
      subtext:[String],
    },
    data() {
      return {
        imgList:{
          'lost':lost,
          'network': network
        },
        imgSrc: null
      }
    },
    created(){
      this.imgSrc =  this.type=== undefined?empty:this.imgList[this.type]
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ax-result-page {
  width: 100%;
  text-align: center;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.approved_box,
.record-box {
  .ax-result-page {
    margin-top: -0.32rem;
  }
}
.ax-result-page .bigImg {
  margin: 0 auto;
}
.ax-result-page p {
  text-align: center;
  font-size: 0.4rem;
  line-height: 1.2rem;
}
.ax-result-page p.gray {
  color: #999;
  line-height: 0.4rem;
}
</style>
